import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const approvalRequestSalaryPaymentListService = (
  params: Types.ApprovalRequestSalaryPaymentListRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestSalaryPaymentListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const approvalRequestSalaryPaymentCreateService = (
  params: Types.ApprovalRequestSalaryPaymentCreateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestSalaryPaymentUpdateService = (
  params: Types.ApprovalRequestSalaryPaymentUpdateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestSalaryPaymentDetailService = (id: string) =>
  RestAPIClient.call<Types.ApprovalRequestSalaryPayment>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const approvalRequestSalaryPaymentApproveService = (
  params: Types.ApprovalRequestSalaryPaymentApproveRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestSalaryPayment>({
    method: HTTPRequestMethods.POST,
    url: Paths.Approve,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
